<template lang="pug">

div

    //- Navigation
    navigation

    //- Services-Status
    table.ui.celled.compact.table(v-if='serviceStatuses.length')
        thead
            tr
                th Service
                th Status
        tbody
            tr(v-for='service in serviceStatuses' v-bind:key='service.name')
                td {{ service.name }}
                td
                    .ui.label(v-bind:class='service.status === "UP" ? "green" : "red"') {{ service.status }}

</template>

<script>
    import store from '@/store'
    import Navigation from '@/components/settings/Navigation.vue'

    export default {
        name: 'settings',

        components: { Navigation },

        data() {
            return {
                serviceStatuses: [],
                servicesLoading: false,
            }
        },

        created() {
            this.loadServiceStatus()
        },

        methods: {

            async loadServiceStatus() {
                this.servicesLoading = true
                try {
                    this.serviceStatuses = await store.dispatch('settings/loadServiceStatus')
                } catch (e) {
                    this.$growl.error('Service-Status konnte nicht geladen werden')
                } finally {
                    this.servicesLoading = false
                }
            },


        },

    }

</script>
